import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Page,
  ResourceList,
  Text,
} from '../../components';
import api from '../../utils/services';

const propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

const MAX_CARRIERS = 1000;

export default class Carriers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      carriers: null,
    };
  }

  componentDidMount() {
    api.getCarriers(MAX_CARRIERS)
      .then((carriers) => {
        this.setState({ carriers });
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  }

  render() {
    const { match } = this.props;
    const { loading, carriers } = this.state;

    return (
      <Page
        title="Carriers"
        subtitle={carriers && `Total carriers: ${carriers.length}`}
        primaryAction={{ content: 'Add carrier', href: `${match.url}/new` }}
      >
        <Card loading={loading}>
          <ResourceList
            items={carriers || []}
            renderItem={carrier => (
              <ResourceList.Item
                key={carrier.id}
                url={`${match.url}/${carrier.id}`}
                id={carrier.id}
              >
                <Text as="h3" noMargins>{carrier.name}</Text>
              </ResourceList.Item>
            )}
          />
          {carriers && carriers.length === MAX_CARRIERS // TODO Support paging
            && <Text fontWeight="bold">Warning! Not all carriers may be displayed.</Text>
          }
        </Card>
      </Page>
    );
  }
}

Carriers.propTypes = propTypes;
